module.exports = __webpack_public_path__ + "resources/img/facetec-audit-trail-examples.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-audit-trail-examples.png
// module id = 1245
// module chunks = 0